import _ from 'lodash';

export const LOCALES = ['en', 'fr'];

// Utilities
export async function loadLocaleMessages() {
    const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });

    // Define all your known module names here
    const moduleNames = ['units', 'devices', 'erp'];
    // Load shared locales
    await Promise.all(LOCALES.map(async locale => {
        const imports = moduleNames.map(moduleName => import(`../aquassist-shared/i18n/${locale}/${moduleName}.json`)
            .then(m => m.default).catch(error => {
                throw new Error(`Failed to load module ${moduleName} for locale ${locale}: ${error}`);
            }));

        try {
            // Wait for all imports to resolve
            const modules = await Promise.all(imports);

            // Filter out any undefined imports (in case of errors) and merge them into the messages object
            modules.filter(Boolean).forEach(module => {
                _.merge(messages[locale], module);
            });
        } catch (error) {
            throw new Error(`Failed to load modules for locale ${locale}: ${error}`);
        }
    }));

    return messages;
}
